(() => {
  'use strict';

  function init(root) {
    if (!root || root.dataset.tgh5Ready === 'true') return;
    root.dataset.tgh5Ready = 'true';

    const shell = root.querySelector('[data-tgh5-shell]');
    const menu = root.querySelector('[data-tgh5-menu]');
    const menuToggle = root.querySelector('[data-tgh5-menu-toggle]');
    const menuTrigger = root.querySelector('[data-tgh5-menu-trigger]');
    const drawer = root.querySelector('[data-tgh5-drawer]');
    const drawerOpen = root.querySelector('[data-tgh5-drawer-open]');
    const drawerClose = root.querySelectorAll('[data-tgh5-drawer-close]');
    const drawerBody = root.querySelector('[data-tgh5-drawer-body]');
    const search = root.querySelector('[data-tgh5-search]');
    const searchToggle = root.querySelector('[data-tgh5-search-toggle]');
    const searchClose = root.querySelector('[data-tgh5-search-close]');
    const searchInput = root.querySelector('[data-tgh5-search-input]');
    const searchFromDrawer = root.querySelector('[data-tgh5-search-from-drawer]');

    const setAccordion = (accordion, open) => {
      if (!accordion) return;
      const toggle = accordion.querySelector('[data-tgh5-accordion-toggle]');
      const body = accordion.querySelector('[data-tgh5-accordion-body]');
      accordion.classList.toggle('is-open', open);
      toggle?.setAttribute('aria-expanded', String(open));
      if (body) body.hidden = !open;
    };

    const resetAccordions = () => {
      drawerBody?.querySelectorAll('[data-tgh5-accordion]').forEach((accordion) => {
        setAccordion(accordion, false);
      });
    };

    drawerBody?.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-tgh5-accordion-toggle]');
      if (!toggle) return;
      event.preventDefault();
      const accordion = toggle.closest('[data-tgh5-accordion]');
      setAccordion(accordion, !accordion?.classList.contains('is-open'));
    });

    const setMenu = (open) => {
      if (!menu) return;
      root.classList.toggle('is-menu-open', open);
      menu.setAttribute('aria-hidden', String(!open));
      menuToggle?.setAttribute('aria-expanded', String(open));
    };

    const setDrawer = (open) => {
      if (!drawer) return;
      root.classList.toggle('is-drawer-open', open);
      drawer.setAttribute('aria-hidden', String(!open));
      drawerOpen?.setAttribute('aria-expanded', String(open));
      document.documentElement.classList.toggle('tgh5-lock', open);
      if (open) {
        setMenu(false);
        resetAccordions();
      } else {
        resetAccordions();
      }
    };

    const setSearch = (open) => {
      if (!search) return;
      search.hidden = !open;
      searchToggle?.setAttribute('aria-expanded', String(open));
      root.classList.toggle('is-search-open', open);
      if (open) {
        setMenu(false);
        setDrawer(false);
        requestAnimationFrame(() => searchInput?.focus());
      }
    };

    menuToggle?.addEventListener('click', (event) => {
      event.preventDefault();
      setMenu(!root.classList.contains('is-menu-open'));
    });

    menuTrigger?.addEventListener('mouseenter', () => {
      if (window.matchMedia('(min-width: 990px)').matches) setMenu(true);
    });

    root.querySelectorAll('.tgh5-nav-item:not(.tgh5-nav-item--menu)').forEach((item) => {
      item.addEventListener('mouseenter', () => {
        if (window.matchMedia('(min-width: 990px)').matches) setMenu(false);
      });
    });

    shell?.addEventListener('mouseleave', () => {
      if (window.matchMedia('(min-width: 990px)').matches) setMenu(false);
    });

    shell?.addEventListener('focusout', (event) => {
      if (window.matchMedia('(min-width: 990px)').matches && !shell.contains(event.relatedTarget)) setMenu(false);
    });

    drawerOpen?.addEventListener('click', () => setDrawer(true));
    drawerClose.forEach((button) => button.addEventListener('click', () => setDrawer(false)));

    searchToggle?.addEventListener('click', () => setSearch(search?.hidden ?? true));
    searchClose?.addEventListener('click', () => setSearch(false));
    searchFromDrawer?.addEventListener('click', () => setSearch(true));

    document.addEventListener('click', (event) => {
      if (!root.contains(event.target)) {
        setMenu(false);
        setSearch(false);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      setMenu(false);
      setDrawer(false);
      setSearch(false);
    });

    window.addEventListener('resize', () => {
      if (window.matchMedia('(min-width: 990px)').matches) setDrawer(false);
      else setMenu(false);
    });

    resetAccordions();
  }

  function initAll(scope = document) {
    scope.querySelectorAll('[data-tgh5]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target || document));
})();
